import { render, staticRenderFns } from "./BroadcastTemplates.vue?vue&type=template&id=6d6c1a52&scoped=true"
import script from "./BroadcastTemplates.vue?vue&type=script&lang=ts"
export * from "./BroadcastTemplates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c1a52",
  null
  
)

export default component.exports